import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { RewardTransactionReportCriteria } from '@shared/models/report.model';
import { BaseService } from '@shared/services/base.service';
import { metricsReporting } from '@shared/utils/metrics-util';

@Injectable()
export class RewardOfferTransactionReportService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.exportReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  reportRewardOfferTransaction(reportCriteria: RewardTransactionReportCriteria) {
    const url = this.getFullUrl(this.envService.rewardOfferTransaction, null, true);
    const metrics = metricsReporting([this.envService.url, this.envService.report]);

    return this.http.post<any>(url, reportCriteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
